const eventNames = {
  dataLayerLoaded: 'dataLayer-loaded',
  pageLoaded: 'page-loaded',
  propertySave: 'property-save',
  selectItem: 'select_item',
  viewItemList: 'view_item_list',
  homepageCarouselTitleClick: 'homepage-carousel-title-click',
  homepageCarouselPropertySave: 'homepage-carousel-property-save',
  carouselPropertyClicked: 'carousel-property-clicked',
  carouselPropertyHover: 'carousel-property-hover',
  photoGridPropertyClicked: 'photo-grid-property-clicked',
  photoGridPropertyHover: 'photo-grid-property-hover',
  hoverEvent: 'hover-event',
  download: 'download',
  localCompsMapClick: 'local-comps-map-click',
  similarPropertySave: 'similar-property-save',
  similarPropertiesClick: 'similar-properties-click',
  bidStatusChange: 'bid-status-change',
  confirmBid: 'confirm-bid',
  confirmProxyBid: 'confirm-proxy-bid',
  purchaseTitleReport: 'purchaseTitleReport',
  print: 'print',
  makeYourOfferPDP: 'make-your-offer-pdp',
  firstLookModal: {
    start: 'first-look-modal-start',
    step2: 'first-look-modal-step-2',
    complete: 'first-look-modal-complete',
    back: 'first-look-modal-back',
    done: 'first-look-modal-done',
  } as const,
  matchWinningBidButtonClick: 'match-winning-bid-button-click',
  matchTheBidConfirm: 'match-the-bid-confirm',
  qualifyRemoteBidButton: 'qualify-remote-bid-button',
  remoteBidQualified: 'remote-bid-qualified',
  offerSubmissionSubmit: 'offer-submission-submit',
  virtualPageview: 'virtual-pageview',
  sellWithUsSubmit: 'sell-with-us-submit',
  sellWithUsSkip: 'sell-with-us-skip',
  onSaveSMSAlertsBoxLoaded: 'on-save-sms-alerts-box-loaded',
  onSaveSMSSubmitClick: 'on-save-sms-submit-click',
  bidDeposit: 'bid_deposit',

  // PS specific events
  myListingsSubmitForReview: 'my-listings-submit-for-review',
  sellerEditListing: 'seller-edit-listing',
  sellerViewOffers: 'seller-view-offers',
  myOffersBuyersView: 'my-offers-buyers-view',
  setReviewOfferDate: 'set-review-offer-date',
  setReviewOfferDateConfirm: 'set-review-offer-date-confirm',
  sellerOfferReviewAccept: 'seller-offer-review-accept',
  sellerAcceptOfferConfirm: 'seller-accept-offer-confirm',
  sellerOfferReviewDecline: 'seller-offer-review-decline',
  sellerDeclineOfferConfirm: 'seller-decline-offer-confirm',
  sellerOfferReviewCounteroffer: 'seller-offer-review-counteroffer',
  sellerOfferReviewSendCounteroffer: 'seller-offer-review-send-counteroffer',
  sellerAuctionReviewUpdateReserve: 'seller-auction-review-update-reserve',
  sellerAuctionConfirmUpdate: 'seller-auction-confirm-update',
  sellerHighestBestLearnMore: 'seller-highest-best-learn-more',
  highestBestInitiateEvent: 'highest-best-initiate-event',
  makeAnOfferSubmit: 'make-an-offer-submit',

  // SRP specific events
  srpPropertyClick: 'srp-property-click',
  srpPropertyClickMobile: 'map-card-click-mobile',
  srpPropertySave: 'srp-property-save',
  prpPropertySave: 'prp-property-save',
  twoClickSaveSearchStart: 'save-search-two-click-start',
  twoClickSaveSearchSuccess: 'save-search-two-click-success',
  twoClickSaveSearchClose: 'save-search-two-click-modal-close',
  oneClickSaveSearchStart: 'save-search-one-click-start',
  oneClickSaveSearchSuccess: 'save-search-one-click-success',
  oneClickSaveSearchUpdateName: 'save-search-one-click-update-name',
  oneClickSaveSearchRemove: 'save-search-one-click-remove',
  oneClickSaveSearchClose: 'save-search-one-click-modal-close',
  mapClick: 'map-click',
  mapClickMobile: 'map-click-mobile',
  mapPinHover: 'map-pin-hover',

  // Event details events
  downloadInventoryClick: 'download-inventory-click',

  // PDP events
  pdpSetAutoBidClick: 'pdp-set-auto-bid-click',
  pdpSetAutoBidConfirm: 'pdp-set-auto-bid-confirm',
  pdpIncreaseAutoBidClick: 'pdp-increase-auto-bid-click',
  pdpIncreaseAutoBidConfirm: 'pdp-increase-auto-bid-confirm',
  pdpAdjustAutoBidClick: 'pdp-adjust-auto-bid-click',
  pdpAdjustAutoBidConfirm: 'pdp-adjust-auto-bid-confirm',
  pdpRemoveAutoBidClick: 'pdp-remove-auto-bid-click',
  pdpRemoveAutoBidConfirm: 'pdp-remove-auto-bid-confirm',
  pdpYourNextBidSubmit: 'pdp-your-next-bid-submit',
  pdpAiAssistantPromptSubmit: 'pdp-ai-assistant-prompt-submit',
  pdpAiConversationStart: 'pdp-ai-conversation-start',
  liveAgentBannerDisplayed: 'live_agent_banner_displayed',
  liveAgentBannerClicked: 'live_agent_banner_clicked',
  contactUsAi: 'contact-us-ai',
  contactUsAiButtonClick: 'contact-us-ai-button-click',
  contactUsAiPromptSubmit: 'contact-us-ai-prompt-submit',
  // PDP photo gallery events
  photoGalleryMounted: 'photo_gallery_mounted',
  photoGalleryOpen: 'photo_gallery_open',
  photoGalleryViewTab: 'photo_gallery_view_tab',

  // PDP EMD badge events
  pdpEmdBadgeExpanded: 'pdp_emd_badge_expanded',

  // Dashboard events
  dashboardBannerDisplayed: 'dashboard_banner_displayed',
  dashboardModalOpened: 'dashboard_modal_opened',
  dashboardPurchaseProfilesSave: 'dashboard-purchase-profiles-save-profile',
  dashboardAlerts: 'dashboard-alerts',
  withdrawOfferClick: 'withdraw-offer-click',
  withdrawOfferConfirmClick: 'withdraw-offer-confirm-click',
  offerDashboardCounterClick: 'offer-dashboard-counter-click',
  offerDashboardAcceptClick: 'offer-dashboard-accept-click',
  offerDashboardModalAcceptClick: 'offer-dashboard-modal-accept-click',
  offerDashboardDeclineClick: 'offer-dashboard-decline-click',
  offerDashboardDeclineModalConfirmLink:
    'dashboard-decline-offer-confirm-click',
  placeRemoteBidButtonClick: 'remote-bid-hub-place-bid-click',
  confirmRemoteBidButtonClick: 'remote-bid-hub-confirm-bid',
  remoteBidPin: 'remote-bid-hub-pin',
  remoteBidUnpin: 'remote-bid-hub-unpin',
  propertyRecommendationsPropertySave: 'property-recommendations-property-save',
  propertyRecommendationsPropertyClick:
    'property-recommendations-property-click',
  dashboardSetAutoBidClick: 'dashboard-set-auto-bid-click',
  dashboardSetAutoBidConfirm: 'dashboard-set-auto-bid-confirm',
  dashboardIncreaseAutoBidClick: 'dashboard-increase-auto-bid-click',
  dashboardIncreaseAutoBidConfirm: 'dashboard-increase-auto-bid-confirm',
  dashboardAdjustAutoBidClick: 'dashboard-adjust-auto-bid-click',
  dashboardAdjustAutoBidConfirm: 'dashboard-adjust-auto-bid-confirm',
  dashboardRemoveAutoBidClick: 'dashboard-remove-auto-bid-click',
  dashboardRemoveAutoBidConfirm: 'dashboard-remove-auto-bid-confirm',
  dashboardYourNextBidSubmit: 'dashboard-your-next-bid-submit',

  // Seller dashboard events
  filtersUpdated: 'filters-updated',
  mapTypeUpdated: 'mapType-updated',
  tabChanged: 'tab-changed',
  editReserveToggled: 'edit-reserve-toggled',
  editContributionToggled: 'edit-reserve-toggled',

  // Agent dashboard events
  activityButtonClick: 'activity-button-click',
  agentListingSubmit: 'agent-listing-submit',

  // registration events
  reoBidderRegistrationFormSubmit: 'reo-bidder-registration-form-submit',
  addSavedPropertiesCheckbox: 'add-saved-properties-checkbox',

  // these 4 registration events were orignally requested for Amplitude,
  // but we'll send it  to ga as well
  bidRegistrationStart: 'bid-registration-start',
  registrationFlowCompleted: 'registration-flow-completed',
  registrationDepositRequiredCompleted:
    'registration-deposit-required-completed',
  registrationAuctionTermsCompleted: 'registration-auction-terms-completed',
  registrationContactDetailsCompleted: 'registration-contact-details-completed',

  // sms opt in
  accountManagementSmsOptInLoaded: 'profile-sms-alerts-box-loaded',
  accountManagementSmsOptInSubmit: 'profile-sms-submit-click',
  remoteBiddingSmsOptInLoaded: 'bidder-qualification-sms-alerts-box-loaded',
  remoteBiddingSmsOptInSubmit: 'bidder-qualification-sms-submit-click',
  fclOnlineSmsOptInLoaded: 'fcl-reg-sms-alerts-box-loaded',
  fclOnlineSmsOptInSubmit: 'fcl-reg-sms-submit-click',
  reoSmsOptInLoaded: 'sms-alerts-box-loaded',
  reoSmsOptInSubmit: 'bidder-info-sms-submit-click',

  // navigation & search
  navigationClick: 'navigation-click',
  buyerDashboardNavClick: 'buyer-dashboard-nav-click',
  accountNavClick: 'account-nav-click',
  srpFiltersButtonClick: 'srp-filters-button-click',
  searchFilterChanged: 'search_filter_changed',
  sort: 'sort',
  searchAreaFilter: 'search-area-filter',

  // buying preferences (MERCH-2288/2291/2296/2297)
  preferencesCenterVisited: 'preferences_center_visited',
  preferencesCenterEdited: 'preferences_center_edited',
  preferencesCenterUpdated: 'preferences_center_updated',
  preferencesCenterConfirmed: 'preferences_center_confirmed',
  preferencesCenterSkipped: 'preferences_center_skipped',
  nudgeShown: 'nudge_shown',
  nudgeCompleted: 'nudge_completed',
  nudgeSkipped: 'nudge_skipped',
  nudgeDismissed: 'nudge_dismissed',
  buyingPreferencesCarouselImpression: 'buying_preferences_carousel_impression',
  buyingPreferencesCarouselUpdatePrefsClick:
    'buying_preferences_carousel_update_prefs_click',
  buyingPreferencesCarouselTabClick: 'buying_preferences_carousel_tab_click',
  buyingPreferencesCarouselLoginCtaClick:
    'buying_preferences_carousel_login_cta_click',

  // logged-out homepage value prop treatment (MERCH-42)
  buyingPreferencesValuePropShown: 'buying_preferences_value_prop_shown',
  buyingPreferencesSignupCtaClicked: 'buying_preferences_signup_cta_clicked',
  buyingPreferencesLoginCtaClicked: 'buying_preferences_login_cta_clicked',

  // Notify Me 2.0 (MERCH-60)
  notifyMeModalShown: 'notify_me_modal_shown',
  notifyMeDoneForNowClick: 'notify_me_done_for_now_click',
  notifyMeTurnOnTextClick: 'notify_me_turn_on_text_click',
  notifyMePhoneVerified: 'notify_me_phone_verified',
  notifyMeConfirmAlertsClick: 'notify_me_confirm_alerts_click',

  // Notify Me 2.0 instrumentation gaps (MERCH-95)
  notifyMeCtaShown: 'notify_me_cta_shown',
  notifyMeCtaClicked: 'notify_me_cta_clicked',
  notifyMeModalDismissed: 'notify_me_modal_dismissed',
  notifyMeEmailEnrolled: 'notify_me_email_enrolled',
  notifyMeSmsEnrolled: 'notify_me_sms_enrolled',
  notifyMeEnrollmentComplete: 'notify_me_enrollment_complete',

  // Dual-Track PDP path selection (MERCH-144 / MERCH-213)
  dualTrackPathSelected: 'dual-track-path-selected',

  // Dashboard redesign / Your Feed (MERCH-172). Raw names are already
  // snake_case, so the Amplitude event name defaults to the key as-is.
  propertyHide: 'property_hide',
  utilityCardClick: 'utility_card_click',

  // Flow tracking events
  flowStepViewed: 'flow-step-viewed',
  flowAdvanced: 'flow:advance',
  flowRetreated: 'flow:retreat',
  flowCompleted: 'flow:complete',
  flowSubmitted: 'flow:submit',
  flowGoto: 'flow:goto',
  flowReturn: 'flow:return',
} as const

// Type exports
export type EventName = (typeof eventNames)[keyof typeof eventNames]
export type FirstLookModalEvent =
  (typeof eventNames.firstLookModal)[keyof typeof eventNames.firstLookModal]

export default eventNames
